import { Box, CircularProgress, Modal, Typography } from "@mui/material"
import React, { useState } from "react"
import CloseIcon from "@mui/icons-material/Close"
import useStyles from "./useStyles"

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 450,
  height: 225,
  bgcolor: "white",
  p: 3,
  borderRadius: "8px",
  boxShadow: "0px 0px 4px rgba(36, 55, 143, 0.4)",
}

export const ConfirmModal = ({
  openModal,
  handleClose,
  handleConfirmFunction,
  title = "",
  message = "",
  optionalMessage = null,
}) => {
  const classes = useStyles()
  const [showCircularProgress, setShowCircularProgress] = useState(false)

  return (
    <>
      <Modal open={openModal} onClose={handleClose}>
        <Box sx={style}>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <CloseIcon
              sx={{
                fontSize: "medium",
                color: "#263057",
                cursor: "pointer",
                fontWeight: "bold",
              }}
              onClick={handleClose}
            />
          </div>
          <div>
            <Typography sx={{ color: "#263057", fontSize: "1.3em" }}>
              {title}
            </Typography>
          </div>
          <Typography
            sx={{
              color: "#263057",
              fontFamily: "Roboto",
              marginTop: "5%",
            }}
          >
            {message}
          </Typography>
          {optionalMessage && (
            <Typography
              sx={{
                color: "#263057",
                fontFamily: "Roboto",
              }}
            >
              {optionalMessage}
            </Typography>
          )}
          <Box className={classes.buttons} style={{ marginLeft: "45%" }}>
            <ButtonConfirm
              showCircularProgress={showCircularProgress}
              setShowCircularProgress={setShowCircularProgress}
              handleConfirmFunction={handleConfirmFunction}
              handleClose={handleClose}
            />

            <ButtonClose handleClose={handleClose} />
          </Box>
        </Box>
      </Modal>
    </>
  )
}
function ButtonConfirm({
  showCircularProgress,
  setShowCircularProgress,
  handleConfirmFunction,
  handleClose,
}) {
  const classes = useStyles()
  const [isProgressComplete, setProgressComplete] = useState(false)

  const handleButtonClick = async () => {
    if (!isProgressComplete && !showCircularProgress) {
      setShowCircularProgress(true)
      await handleConfirmFunction()
      setShowCircularProgress(false)
      setProgressComplete(true)
      handleClose()
    }
  }

  return (
    <div style={{ position: "relative", display: "inline-block" }}>
      <button
        className={`${classes.confirmButton} ${
          isProgressComplete ? classes.disabledButton : ""
        }`}
        disabled={isProgressComplete || showCircularProgress}
        onClick={handleButtonClick}
      >
        {showCircularProgress ? (
          <CircularProgress size="1.5rem" color="inherit" />
        ) : (
          <Typography className={classes.confirmButtonTypography}>
            Confirmar
          </Typography>
        )}
      </button>
    </div>
  )
}

function ButtonClose({ handleClose }) {
  const classes = useStyles()

  return (
    <Box onClick={handleClose} className={classes.closeButton}>
      <Typography className={classes.closeButtonColor}>Cancelar</Typography>
    </Box>
  )
}
